export const validatePassword = (pw: string) =>
  /[A-Z]/.test(pw) && /[0-9]/.test(pw) && pw.length > 8;

export const isTextRTL = (text: string) => {
  const hebrewChars = new RegExp('^[\u0590-\u05FF]');
  const arabicChars = new RegExp('^[\u0621-\u064A]');
  return hebrewChars.test(text) || arabicChars.test(text);
};

interface MSCryptoWindow extends Window {
  msCrypto: Crypto;
}

export const getRandomId = () => {
  const array = new Uint32Array(64);
  const crypto =
    window.crypto || (window as unknown as MSCryptoWindow).msCrypto;
  crypto.getRandomValues(array);

  const hex: string[] = [];

  array.forEach((a) => hex.push(a.toString(16)));
  return hex.join('').substring(0, 64).toUpperCase();
};

export const validateTime = (time: string) =>
  /^(?:[01][0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$/.test(time);

export const downloadFile = (fileData: Blob, fileName: string) => {
  const url = window.URL.createObjectURL(fileData);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const hexToRgb = (hex: string, opacity?: number) => {
  let hexWithoutHash = hex;
  if (hex[0] === '#') {
    hexWithoutHash = hex.slice(1, 7);
  }
  const rValue = parseInt(hexWithoutHash.substring(0, 2), 16);
  const gValue = parseInt(hexWithoutHash.substring(2, 4), 16);
  const bValue = parseInt(hexWithoutHash.substring(4), 16);
  if (opacity) {
    return `rgba(${rValue}, ${gValue}, ${bValue}, ${opacity})`;
  }
  return `rgb(${rValue}, ${gValue}, ${bValue})`;
};

export function formatDateTime(date: Date) {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const day = date.getDate();
  const month = months[date.getMonth()];
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');

  // Format: MMM DD, HH:mm
  return `${month} ${day}, ${hours}:${minutes}`;
}
